<template>
  <el-dialog width="40%"
             title="查看"
             :visible.sync="viewDetail"
             @close="closeModel">
    <el-row :gutter="20">
      <el-col :span="4">
        订单号
      </el-col>
      <el-col :span="20">
        {{details_list.orders_sn}}
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="4">
        商品名称
      </el-col>
      <el-col :span="20">
        {{details_list.goods_names}}
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="4">
        商品数量
      </el-col>
      <el-col :span="20">
        {{details_list.goods_number}}
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="4">
        交易金额
      </el-col>
      <el-col :span="20">
        {{details_list.goods_payments_amounts}}
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="4">
        活动名称
      </el-col>
      <el-col :span="20">
        {{details_list.rebate_name}}
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="4">
        经纪人名称
      </el-col>
      <el-col :span="20">
        {{details_list.agent_name}}
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="4">
        分润比例
      </el-col>
      <el-col :span="20">
        {{details_list.proportion}}
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="4">
        分润金额
      </el-col>
      <el-col :span="20">
        {{details_list.proportion_price}}
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
export default {
  props: {
    details_list: {
      type: Object
    }

  },
  data () {
    return {
      viewDetail: true,

    };
  },
  methods: {
    closeModel () {
      this.$emit("closeModel");
    },

  },
  components: {

  },
};
</script>

<style scoped lang="scss">
::v-deep .el-row{
  height: 40px;

}
</style>
